import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2ToolIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 21.267 21.271",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 21.271),
    children: [/*#__PURE__*/jsx("path", {
      d: "m18.886 10.967a6.051 6.051 0 0 0 1.169-6.889l-3.075 3.075a2.023 2.023 0 0 1 -2.86-2.861l3.075-3.075a6.034 6.034 0 0 0 -8.057 8.055l-7.892 7.893a2.023 2.023 0 1 0 2.86 2.858l7.892-7.891a6.051 6.051 0 0 0 6.887-1.168z"
    }), /*#__PURE__*/jsx("path", {
      d: "m14.114 6.653 4.264 4.265"
    })]
  });
};

export { PM2ToolIcon };
//# sourceMappingURL=tool.js.map
